import { render, staticRenderFns } from "./SvgSection8.vue?vue&type=template&id=6f5472df&"
import script from "./SvgSection8.vue?vue&type=script&lang=js&"
export * from "./SvgSection8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports